import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import bgImage from "../assets/bg.jpg";  // ✅ Import da imagem de fundo

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/projects");
    } catch (err) {
      setError("Email ou senha inválidos.");
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        backgroundImage: `url(${bgImage})`,  // ✅ Aplicação do background
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div 
        className="p-10 rounded-2xl shadow-lg w-full max-w-sm space-y-6"
        style={{ backgroundColor: '#d5c1b6' }}
      >
        <div className="flex justify-center">
          <img
            src={require('../assets/logo.png')}
            alt="Logo Bruna Bündchen"
            className="h-16"
          />
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="email"
            placeholder="Email"
            className="border px-3 py-2 rounded w-full"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            type="password"
            placeholder="Senha"
            className="border px-3 py-2 rounded w-full"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {error && <p className="text-red-500 text-sm -mt-2">{error}</p>}

          <button
            type="submit"
            className="w-full bg-[#b29d92] hover:bg-[#b29d92] text-white px-4 py-2 rounded font-semibold"
          >
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
